import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { Helmet } from "react-helmet-async";
import { hyphenate } from "../../../features/hyphenate";
import { notNullOrWhitespace } from "../../../utils/string";
import { LinkButton } from "../../Button";
import { Container } from "../../Container";
import { ResponsivePicture } from "../../Image";
import { Link } from "../../Link";
import { CollectionItemSlide, CollectionItemSlider } from "../CollectionItemSlider/CollectionItemSlider";
import { searchParams } from "../CollectionOverview/CollectionOverviewUtils";
import { pushCollectionAction, titleAndAuthor } from "../CollectionUtils";
import { CollectionItemAvailability } from "./CollectionItemAvailability";
import { CollectionItemLongDescription } from "./CollectionItemLongDescription";
import { CollectionItemSpecs } from "./CollectionItemSpecs";
const availabilityId = "ci__availability";
export const CollectionItemDetailsLayout = (param)=>{
    let { item, itemId, recommendations, route, preferredBranchId } = param;
    const availabilityCount = item.copies ? item.copies.filter((c)=>c.status === "available").length : 0;
    const recs = recommendations.kind == 'loaded' && recommendations.value;
    const { authors, mainTitle, subtitle, series, volumeTitle, shortDescription, longDescription, originalUrl, OriginalId, image, descriptiveTerms: terms, genre } = item;
    const uniqueIntro = (longDescription === null || longDescription === void 0 ? void 0 : longDescription.startsWith(shortDescription === null || shortDescription === void 0 ? void 0 : shortDescription.slice(0, -5))) ? "" : shortDescription;
    const author = (authors === null || authors === void 0 ? void 0 : authors[0]) || "";
    // if volume only contains numbers, add "deel" prefix
    const volumeNumber = item.volume && item.volume.match(/^\d+$/) ? `Deel ${item.volume}` : "";
    const volume = [
        volumeNumber.trim(),
        volumeTitle.trim()
    ].filter((x)=>!!x).join(" — ");
    // Interactions
    const reservationUrl = `${originalUrl}(modal:hold/${OriginalId}/place)`;
    const reservationButton = /*#__PURE__*/ _jsx("div", {
        className: "ci__cta",
        children: /*#__PURE__*/ _jsxs(LinkButton, {
            variant: "primary",
            route: reservationUrl,
            handle: ()=>push("Reserveer", mainTitle),
            children: [
                /*#__PURE__*/ _jsx("svg", {
                    width: "1.2rem",
                    height: "1.2rem",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ _jsx("use", {
                        xlinkHref: "#icon--calendar-check"
                    })
                }),
                "Reserveer"
            ]
        })
    });
    const push = pushCollectionAction();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Helmet, {
                children: [
                    /*#__PURE__*/ _jsx("title", {
                        children: titleAndAuthor(item)
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "collection__item-page",
                children: [
                    /*#__PURE__*/ _jsxs(Container, {
                        size: "m",
                        gutter: true,
                        className: "ci__container",
                        children: [
                            /*#__PURE__*/ _jsxs("header", {
                                className: "ci__header",
                                children: [
                                    /*#__PURE__*/ _jsx("nav", {
                                        className: "collection__breadcrumbs ci__breadcrumbs",
                                        children: /*#__PURE__*/ _jsxs(Link, {
                                            className: "back-link",
                                            url: route,
                                            handle: ()=>{
                                                history.length > 1 && history.back();
                                                push("Terug naar overzicht", mainTitle);
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("svg", {
                                                    className: "chevron-left",
                                                    width: "1.5rem",
                                                    height: "1.5rem",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ _jsx("use", {
                                                        xlinkHref: "#icon--chevron-left-large"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Terug naar overzicht"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "header__content",
                                        children: [
                                            series && series.length > 0 && series.map((s)=>/*#__PURE__*/ _jsx("div", {
                                                    className: "ci__series title--sm",
                                                    children: s
                                                })),
                                            /*#__PURE__*/ _jsx("h1", {
                                                className: "header__title ci__title title--xl",
                                                children: hyphenate(mainTitle)
                                            }),
                                            subtitle && /*#__PURE__*/ _jsx("div", {
                                                className: "ci__subtitle title--sm",
                                                children: subtitle
                                            }),
                                            volume && /*#__PURE__*/ _jsx("div", {
                                                className: "ci__volume text--s",
                                                children: volume
                                            }),
                                            author && /*#__PURE__*/ _jsx("div", {
                                                className: "ci__authors",
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    url: `${route}${searchParams({
                                                        query: author
                                                    })}`,
                                                    handle: ()=>{
                                                        push("Zoek op auteur", author);
                                                    },
                                                    children: author
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "ci__sidebar",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "ci__cover-and-ctas",
                                    children: [
                                        image && /*#__PURE__*/ _jsx("div", {
                                            className: "ci__cover",
                                            children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                                                imgClassName: "ci__cover-img",
                                                defaultImageUrl: image.Header,
                                                cropsPerMedia: [
                                                    {
                                                        crops: [
                                                            {
                                                                url: image.Header,
                                                                width: 400
                                                            },
                                                            {
                                                                url: image.Header2x,
                                                                width: 800
                                                            }
                                                        ]
                                                    }
                                                ],
                                                lazyload: false,
                                                width: 280,
                                                height: 420,
                                                alt: `Omslag: ${image.AltText}`
                                            })
                                        }, `cover-${image.Header}`),
                                        availabilityCount > 0 && /*#__PURE__*/ _jsx("div", {
                                            className: "ci__available",
                                            children: /*#__PURE__*/ _jsxs(Link, {
                                                url: `#${availabilityId}`,
                                                handle: ()=>{
                                                    // determine if a nav element with class 'sticky' exists, if so scroll to offsetTop - its height
                                                    const nav = document.querySelector('nav');
                                                    const offset = nav ? nav.clientHeight + 20 : 0;
                                                    scrollTo(0, document.getElementById(availabilityId).offsetTop - offset);
                                                    push("Bekijk beschikbaarheid", mainTitle);
                                                },
                                                className: "ci__available-link",
                                                children: [
                                                    /*#__PURE__*/ _jsx("svg", {
                                                        width: "1.5rem",
                                                        height: "1.5rem",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ _jsx("use", {
                                                            xlinkHref: "#icon--check"
                                                        })
                                                    }),
                                                    `Beschikbaar op ${availabilityCount} locatie${availabilityCount > 1 ? "s" : ""}`
                                                ]
                                            })
                                        }),
                                        reservationButton
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "ci__content",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "ci__data",
                                        children: [
                                            uniqueIntro && /*#__PURE__*/ _jsx("div", {
                                                className: "ci__description-short",
                                                children: uniqueIntro
                                            }),
                                            /*#__PURE__*/ _jsx(CollectionItemSpecs, {
                                                className: "ci__specs",
                                                item: item
                                            }),
                                            item.longDescription && /*#__PURE__*/ _jsx(CollectionItemLongDescription, {
                                                longDescription: item.longDescription
                                            }),
                                            /*#__PURE__*/ _jsx(Genres, {
                                                className: "ci__genres",
                                                genre,
                                                route
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(CollectionItemAvailability, {
                                        className: "ci__availability",
                                        id: availabilityId,
                                        copies: item.copies ?? [],
                                        preferredBranchId: preferredBranchId,
                                        medium: item.medium
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "ci__links",
                                        children: reservationButton
                                    })
                                ]
                            })
                        ]
                    }),
                    (recs === null || recs === void 0 ? void 0 : recs.length) > 0 && /*#__PURE__*/ _jsx(Container, {
                        size: "m",
                        gutter: true,
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "collection-item__recommendations",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "title--l",
                                    children: "Lees ook eens"
                                }),
                                /*#__PURE__*/ _jsx(CollectionItemSlider, {
                                    className: "bookslider bookslider--recommendations",
                                    children: recs.map((item)=>/*#__PURE__*/ _jsx(CollectionItemSlide, {
                                            key: item.Id,
                                            item,
                                            route,
                                            push: ()=>push('Volg aanbeveling', titleAndAuthor(item))
                                        }))
                                })
                            ]
                        })
                    })
                ]
            }, itemId)
        ]
    });
};
const Genres = (param)=>{
    let { genre, route, className } = param;
    if (!genre) return /*#__PURE__*/ _jsx(_Fragment, {});
    const genres = genre.filter(notNullOrWhitespace);
    if (genres.length == 0) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "sr-text",
                children: "Genre:"
            }),
            /*#__PURE__*/ _jsx("ul", {
                children: genres.map((t)=>/*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(Link, {
                            className: "button button--primary",
                            url: `${route}${searchParams({
                                genre: [
                                    t
                                ]
                            })}`,
                            handle: ()=>{
                                pushCollectionAction()("Zoek op genre", t);
                            },
                            children: t
                        })
                    }, t))
            })
        ]
    });
};
